export default {
  'talk.title': 'Informations sur le groupe',
  'talk.btn.add': 'Ajouter un groupe',
  'talk.btn.guard': 'Télécharger Garde',
  'talk.table.name': 'Nom de groupe',
  'talk.input.name': 'Veuillez saisir le nom du groupe',
  'talk.download.nodata':
    "Il n'y a pas d'appareil à télécharger. Veuillez entrer l'appareil avant de télécharger les données",
};
